import { useEffect } from 'react';

import { useConsumeQueryParam } from '@/hooks/useConsumeQueryParam';
import { EDIT_TESTAMENTARY_ENTITY_ID_QUERY_PARAM } from '@/modules/notifications/utils/aiSuggestionRegen';

/**
 * Deep-link: auto-open the testamentary entity modal when navigating from an
 * AI suggestion regen notification for a sub-trust. useConsumeQueryParam
 * clears the param from the URL after we handle it, so unrelated state
 * changes don't re-open the modal, while a later navigation with a different
 * ID still re-triggers the effect.
 */
export function useAutoOpenTestamentaryEntityFromDeepLink(
  setEditTestamentaryDetails: (details: {
    testamentaryEntityId: string;
  }) => void
) {
  const {
    value: editTestamentaryEntityIdParam,
    consume: consumeEditTestamentaryEntityIdParam,
  } = useConsumeQueryParam(EDIT_TESTAMENTARY_ENTITY_ID_QUERY_PARAM);

  useEffect(() => {
    if (!editTestamentaryEntityIdParam) return;
    setEditTestamentaryDetails({
      testamentaryEntityId: editTestamentaryEntityIdParam,
    });
    consumeEditTestamentaryEntityIdParam();
  }, [
    consumeEditTestamentaryEntityIdParam,
    editTestamentaryEntityIdParam,
    setEditTestamentaryDetails,
  ]);
}
